import { useMemo, useState } from "react";
import InfoLayout from "../components/InfoLayout";
import usePageMeta from "../hooks/usePageMeta";

const categoryLabels = {
  "how-to": "How To",
  "jargon-buster": "Jargon-Busters",
  "know-the-rules": "Know The Rules",
  "buyer-tips": "Buyer Tips",
};

export default function GuidesIndexPage({ brand }) {
  const copy = brand.guidesIndex;
  usePageMeta({
    title: copy?.title || `Guides | ${brand.name}`,
    description: copy?.description || `Plain-language guides on vehicle history, service records and used-car checks from ${brand.name}.`,
    canonical: `https://${brand.domain}/guides/`,
  });

  const guides = brand.guides || [];
  const categories = useMemo(() => {
    const seen = [...new Set(guides.map((g) => g.category).filter(Boolean))];
    return seen;
  }, [guides]);
  const [active, setActive] = useState("all");
  const shown = active === "all" ? guides : guides.filter((g) => g.category === active);

  return (
    <InfoLayout brand={brand} eyebrow="" title="" intro="">
      <section className="content">
        <div className="wrap">
          <div className="guides-hero">
            <img src="/guides.svg" alt="" className="guides-icon" />
            <span className="guides-pill">Learn</span>
            <h1>{copy?.heading || "Vehicle history, explained clearly."}</h1>
            <p className="guides-sub">{copy?.sub || "Practical, plain-language guides to help you understand a used car's history before you buy."}</p>

            {categories.length > 1 && (
              <div className="guides-filters" role="tablist" aria-label="Filter guides by topic">
                <button type="button" className={`guides-filter${active === "all" ? " is-active" : ""}`} onClick={() => setActive("all")}>All</button>
                {categories.map((cat) => (
                  <button type="button" key={cat} className={`guides-filter${active === cat ? " is-active" : ""}`} onClick={() => setActive(cat)}>
                    {categoryLabels[cat] || cat}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="guides-list">
            {shown.length === 0 && <div className="guides-empty">No guides in this category yet.</div>}
            {shown.map((guide) => (
              <div className="guides-list-row" key={guide.slug}>
                <a href={guide.slug}>{guide.title}</a>
                <span className="guides-chevron" aria-hidden="true">›</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </InfoLayout>
  );
}
